/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Visibility_Unlisted_DescInputs */

const en_dialog_visibility_unlisted_desc = /** @type {(inputs: Dialog_Visibility_Unlisted_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only people you invited, or sent a Share link to, can view and listen`)
};

const es_dialog_visibility_unlisted_desc = /** @type {(inputs: Dialog_Visibility_Unlisted_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo las personas que invitaste o a quienes enviaste un enlace pueden ver y escuchar`)
};

/**
* | output |
* | --- |
* | "Only people you invited, or sent a Share link to, can view and listen" |
*
* @param {Dialog_Visibility_Unlisted_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_visibility_unlisted_desc = /** @type {((inputs?: Dialog_Visibility_Unlisted_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Visibility_Unlisted_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_visibility_unlisted_desc(inputs)
	return en_dialog_visibility_unlisted_desc(inputs)
});